import {
  Breadcrumbs,
  Page,
  PageBody,
  PageBreadcrumbs,
  PageHeader,
  PageHeaderTitle,
  PageHeaderDescription,
  PageHeaderTabs,
} from '@customerio/pluma-components/react';
import { Helmet } from 'react-helmet-async';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { EmailSettingsTabs } from './email-settings-tabs';

interface EmailSettingsLayoutProps {
  title: string;
  children: React.ReactNode;
}

export function EmailSettingsLayout({ title, children }: EmailSettingsLayoutProps) {
  const workspaceId = getWorkspaceIdFromCurrentUrl();
  const breadcrumbs = [
    { text: 'Workspace settings', href: `/workspaces/${workspaceId}/settings` },
    { text: 'Email', href: `/workspaces/${workspaceId}/settings/actions/email/sending_domains` },
    { text: 'Account verification' },
  ];

  return (
    <>
      <Helmet>
        <title>{title} | Customer.io</title>
      </Helmet>
      <Page style={{ width: '100%' }}>
        <PageBreadcrumbs>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </PageBreadcrumbs>
        <PageHeader>
          <PageHeaderTitle>Email</PageHeaderTitle>
          <PageHeaderDescription>Manage email settings and configurations for your workspace.</PageHeaderDescription>
          <PageHeaderTabs>
            <EmailSettingsTabs />
          </PageHeaderTabs>
        </PageHeader>
        <PageBody>{children}</PageBody>
      </Page>
    </>
  );
}
